// components/Navbar.jsx
import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import "../App.css";

function Navbar() {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        {/* <img
          src={"/blog-images/ChessAssessIcon.png"}
          alt={"ChessAssess"}
          className="sidebar-item-image"
        /> */}
        <Link to="/">
          ChessAssess
        </Link>
      </div>

      <div className="navbar-links desktop-only">
        <NavLink to="/">Home</NavLink>
        <NavLink to="/blog">Blog</NavLink>
        <div className="dropdown">
          <span>Tournaments ▾</span>
          <div className="dropdown-content">
            <NavLink to="/tournaments/comingsoon">Coming Soon</NavLink>
            {/* <NavLink to="/tournaments/worldcup2023">World Cup 2023</NavLink>
            <NavLink to="/tournaments/candidates2024">Candidates 2024</NavLink> */}
          </div>
        </div>
        <NavLink to="/openingtrainer">Opening Trainer</NavLink>
      </div>

      <button
        className="hamburger mobile-only"
        onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
      >
        ☰

        {isMobileMenuOpen && (
          <div className="mobile-menu mobile-only">
            <NavLink to="/" onClick={() => setMobileMenuOpen(false)}>Home</NavLink>
            <NavLink to="/blog" onClick={() => setMobileMenuOpen(false)}>Blog</NavLink>
            <NavLink to="/tournaments/comingsoon" onClick={() => setMobileMenuOpen(false)}>Coming Soon</NavLink>
            {/* <NavLink to="/tournaments/worldcup2023" onClick={() => setMobileMenuOpen(false)}>World Cup 2023</NavLink>
            <NavLink to="/tournaments/candidates2024" onClick={() => setMobileMenuOpen(false)}>Candidates 2024</NavLink> */}
            <NavLink to="/openingtrainer" onClick={() => setMobileMenuOpen(false)}>Opening Trainer</NavLink>
          </div>
        )}
      </button>
    </nav>
  );
}

export default Navbar;
